import type { ErrorEvent } from '@sentry/react';

const INJECTED_EXTRACTION_FUNCTION = 'updateAndCleanExtractedContent';
const INJECTED_EXTRACTION_SIGNATURE = /(?:^|\s)updateAndCleanExtractedContent@/;

/**
 * `updateAndCleanExtractedContent` belongs to a content-extraction script a
 * browser or extension injects into the page; no source in this repository
 * defines it. Matching is exact on the frame function and on the
 * `name@url:line:col` stack signature, so a first-party extraction error or a
 * same-prefix function name still reports.
 */
export function isInjectedExtractionScript(event: ErrorEvent): boolean {
  if (typeof event.message === 'string' && INJECTED_EXTRACTION_SIGNATURE.test(event.message)) {
    return true;
  }
  return (
    event.exception?.values?.some(
      (value) =>
        (typeof value.value === 'string' && INJECTED_EXTRACTION_SIGNATURE.test(value.value)) ||
        (value.stacktrace?.frames?.some((f) => f.function === INJECTED_EXTRACTION_FUNCTION) ??
          false),
    ) ?? false
  );
}
